<!--s
 * @Description: 成绩学分管理 班级成绩查询
 * @Author: PF
 * @Date: 2023-01-03 11:03:45
 * @LastEditors: PF
 * @LastEditTime: 2023-01-04 10:51:10
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Suitcase />
          </el-icon>
          <span class="header-title">成绩查询</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
              <el-form-item>
                <el-select v-model="dataGrid.parms.xqid" placeholder="学期" clearable filterable>
                  <el-option v-for="(item, index) in xqidList" :key="index" :label="item.xqmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select placeholder="系部" v-model="dataGrid.parms.xbid" clearable filterable @change="initZhuanYeList">
                  <el-option v-for="item in xbData" :key="item.id" :label="item.jgmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="dataGrid.parms.zyid" placeholder="专业" clearable filterable @change="initBanJiList">
                  <el-option v-for="(item, index) in zyidList" :key="index" :label="item.zymc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="dataGrid.parms.njid" placeholder="年级" clearable filterable @change="initBanJiList">
                  <el-option v-for="(item, index) in njidList" :key="index" :label="item.njmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model="dataGrid.parms.bjid" placeholder="班级" clearable filterable @change="bindTable()">
                  <el-option v-for="(item, index) in bjidList" :key="index" :label="item.xzbmc" :value="item.id" />
                </el-select>
              </el-form-item>

            </el-form>
            <!-- 按钮区域 -->
            <div class="top_but">
              <ul class="checkbox_group">
                <li>
                  <span class="changdu">成绩类型：</span>
                  <el-checkbox-group v-model="xzcjlx" @change="chengJiChange">
                    <el-checkbox v-for="(item, index) in cjlxList" :key="index" :label="item.id">{{ item.label
                    }}</el-checkbox>
                  </el-checkbox-group>
                </li>
                <li>
                  <span class="changdu">显示科目：</span>
                  <el-checkbox-group v-model="xzkm" @change="keMuChange">
                    <el-checkbox v-for="(item, index) in kmList" :key="index" :label="item.id">{{ item.kmmc }}</el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </div>
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <el-table-column prop="xsxh" fixed label="学号" align="center" min-width="100" show-overflow-tooltip />
              <el-table-column prop="xsxm" fixed label="学生姓名" align="center" min-width="100" show-overflow-tooltip />
              <el-table-column prop="xb" label="性别" align="center" show-overflow-tooltip />
              <el-table-column v-for="(item, index) in tableHeader" :key="index" :prop="item.prop" :label="item.kmmc" align="center">
                <el-table-column :prop="child.prop" :label="child.label" v-for="(child, childIndex) in item.children" :key="childIndex" align="center" min-width="100">
                  <template #default="scope">
                    <div v-for="(val, i) in scope.row.zpcjs" :key="i">
                      <div v-for="(xzcj, j) in xzcjList" :key="j">
                        <div v-if="xzcj.id === '1' && child.prop === 'ps' && item.kmmc === val.kmmc">
                          <p>{{val.psfs}}</p>
                        </div>
                        <div v-if="xzcj.id === '2' && child.prop === 'qz' && item.kmmc === val.kmmc">
                          <p>{{val.qzfs}}</p>
                          <!-- 0-正常考试，1-免考，2-免修，3-缺考 -->
                          <p v-if="val.qzckzt === 0">缺考</p>
                          <p v-if="val.qzckzt === 2">免考</p>
                          <p v-if="val.qzckzt === 3">免修</p>
                          <p v-if="val.qzckzt === 4">延期考试</p>
                        </div>
                        <div v-if="xzcj.id === '3' && child.prop === 'qm' && item.kmmc === val.kmmc">
                          <p>{{val.qmfs}}</p>
                          <!-- 0-正常考试，1-免考，2-免修，3-缺考 -->
                          <p v-if="val.qzckzt === 0">缺考</p>
                          <p v-if="val.qzckzt === 2">免考</p>
                          <p v-if="val.qzckzt === 3">免修</p>
                          <p v-if="val.qzckzt === 4">延期考试</p>
                        </div>
                        <div v-if="xzcj.id === '4' && child.prop === 'zp' && item.kmmc === val.kmmc">{{val.fs}}</div>
                        <div v-if="xzcj.id === '5' && child.prop === 'dj' && item.kmmc === val.kmmc">{{val.djmc}}</div>
                        <div v-if="xzcj.id === '6' && child.prop === 'jd' && item.kmmc === val.kmmc">{{val.jd}}</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column v-if="isZcj" prop="zcj" label="总成绩" align="center" show-overflow-tooltip>
                <template #default="scope">
                  {{ scope.row.zcj }}
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <!-- 分页 -->
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
    <!-- 办理 弹窗 结束 -->
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import pagination from '@/components/pagination.vue'
import {
  loadList,
  loadSelect,
  actionPost,
  homeCloseWindow
} from '@/api/common.js'

const props = defineProps({
  open: { type: String, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['openReturn', 'ReturnData'])

// 搜索区域 开始
const xqid = ref() // 学期ID
const njidList = ref([]) // 年级列表
const zyidList = ref([]) // 专业列表
const bjidList = ref([]) // 班级列表
const xqidList = ref([]) // 学期列表
// 搜索区域 结束

// 复选区域 开始
const xzcjlx = ref([]) // 选中成绩类型
const xzcjList = ref([]) // 选中成绩列表
const xzkm = ref([]) // 选中科目
const xzkmList = ref([]) // 选中科目列表
const isZcj = ref(false) // 是否显示总成绩
const cjlxList = ref([
  { id: '1', prop: 'ps', label: '平时成绩' },
  { id: '2', prop: 'qz', label: '期中成绩' },
  { id: '3', prop: 'qm', label: '期末成绩' },
  { id: '4', prop: 'zp', label: '总评成绩' },
  { id: '5', prop: 'dj', label: '成绩等级' },
  { id: '6', prop: 'jd', label: '绩点' }
])
const kmList = ref([])
const tableHeader = ref([])

const chengJiChange = () => {
  xzcjList.value = []
  cjlxList.value.forEach((element) => {
    xzcjlx.value.forEach((e) => {
      if (element.id === e) {
        xzcjList.value.push(element)
      }
    })
  })
  initKeMuList()
}
// 选择 显示科目
const keMuChange = () => {
  xzkmList.value = []
  kmList.value.forEach((element) => {
    xzkm.value.forEach((e) => {
      if (element.id === e) {
        isZcj.value = e === '1'
        xzkmList.value.push(element)
      }
    })
  })
  initKeMuList()
}

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'xh', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
// 列表
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/jiaowu/chengjizongpingchengji/banjilist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
      kechengliebiao()
      xzcjlx.value = ['1', '2', '3', '4', '5', '6']
      chengJiChange()
      keMuChange()
    }
  })
}
// 下拉列表
const initSelectList = async () => {
  // 学期列表
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: xqidList,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          dataGrid.value.parms.xqid = element.id
          initNianJiList()
          initZhuanYeList()
          initBanJiList()
        }
      })
    }
  })
}

// 班级列表
const initBanJiList = () => {
  if (!dataGrid.value.parms.zyid || !dataGrid.value.parms.njid) {
    bindTable()
    return
  }
  const info = {
    menuId: sessionStorage.getItem('menuId'),
    xqid: dataGrid.value.parms.xqid, // 学期ID
    zyid: dataGrid.value.parms.zyid,
    njid: dataGrid.value.parms.njid
  }
  loadSelect({
    url: '/api/v2/pdp/banji/list',
    data: bjidList,
    parms: info,
    order: 'xzbdm',
    sort: 'asc',
    loadSuccess: function (res) {
      dataGrid.value.parms.bjid = res.data[0].id
      bindTable()
    }
  })
}
// 年级列表
const initNianJiList = () => {
  const info = {
    menuId: sessionStorage.getItem('menuId'),
    bjid: dataGrid.value.parms.bjid // 班级ID
  }
  loadSelect({
    url: '/api/v2/pdp/nianji/list',
    data: njidList,
    prams: info,
    order: 'njdm',
    sort: 'asc',
    loadSuccess: function (res) {
      dataGrid.value.parms.njid = res.data[0].id
    }
  })
}
// 专业列表
const initZhuanYeList = () => {
  actionPost({
    url: '/api/v2/pdp/zhuanye/list',
    data: {
      menuId: sessionStorage.getItem('menuId'),
      xbid: dataGrid.value.parms.xbid
    }
  }).then((res) => {
    zyidList.value = res.data
    dataGrid.value.parms.zyid = res.data[0].id
    dataGrid.value.parms.bjid = null
  })
}
const initKeMuList = () => {
  tableHeader.value = []
  xzkmList.value.forEach((element) => {
    if (element.kmmc !== '总成绩') {
      const obj = {
        kmmc: element.kmmc,
        children: xzcjList.value
      }
      tableHeader.value.push(obj)
    }
  })
}
const kechengliebiao = () => {
  const obj = {
    bjid: dataGrid.value.parms.bjid,
    xqid: dataGrid.value.parms.xqid
  }
  loadSelect({
    url: '/api/v2/jiaowu/chengjizongpingchengji/banjikemu',
    data: kmList,
    parms: obj,
    loadSuccess: function (res) {
      kmList.value.push({ id: '1', kmmc: '总成绩' })
      dataGrid.value.parms.kmid = res.data[0].id
      xzkm.value = []
      xzkmList.value = []
      kmList.value.forEach((element) => {
        xzkm.value.push(element.id)
        xzkmList.value.push(element)
        if (element.kmmc !== '总成绩') {
          const obj = {
            kmmc: element.kmmc,
            children: xzcjList.value
          }
          tableHeader.value.push(obj)
          isZcj.value = true
        }
      })
      initKeMuList()
    }
  })
}

const openList = ref(false)

watch(
  () => props.open,
  () => {
    if (props.open === 'chengjichaxun') {
      openList.value = true
      initSelectList()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>

  <style lang="less" scoped>
.checkbox_group {
  li {
    display: flex;
    align-items: center;
  }
}
</style>
